import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import MetamaskProvider from './contexts/Metamask';
import { BrowserRouter } from 'react-router-dom';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SplashScreen from 'components/splashScreen';
import { ChakraProvider } from '@chakra-ui/react';

toast.configure({
  theme: 'colored',
  style: { marginTop: 80, marginRight: 20 },
});

ReactDOM.render(
  <>
  <ChakraProvider>
    <SplashScreen />
  </ChakraProvider>
  <React.StrictMode>
    <MetamaskProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MetamaskProvider>
  </React.StrictMode>
  </>,
  document.getElementById('root'),
);
